import React, { useState, useEffect } from "react";
import {
  X,
  Loader2,
  AlertCircle,
  Check,
  X as XIcon,
  PlusCircle,
  Pencil,
  Trash2,
  EyeClosed 
} from "lucide-react";
import { uploadQuestionImg } from "../../api/quizeApi";
import CreateQuestion from "./questions/CreateQuestion";
import UpdateQuestion from "./questions/UpdateQuestion";
const apiBase = process.env.REACT_APP_API;

const QuizeQuestions = ({ isOpen, onClose, quizId }) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    hasMore: false,
  });

  const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
  const [isEditQuestionModalOpen, setIsEditQuestionModalOpen] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(null);

  const [refreshFlag, setRefreshFlag] = useState(false);

  // State for the new question form
  const [newQuestion, setNewQuestion] = useState({
    question_text: "",
    question_type: "single", // single or multiple
    answers: [
      { answer_text: "", is_correct: false },
      { answer_text: "", is_correct: false },
    ],
    question_img: null,
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [formSubmitting, setFormSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen && quizId) {
      fetchQuestions();
    }
  }, [isOpen, quizId, pagination.currentPage, refreshFlag]);

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `${apiBase}/quize/questions/${quizId}?page=${pagination.currentPage}&limit=${pagination.pageSize}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch questions");
      }

      const data = await response.json();

      if (data.questions && Array.isArray(data.questions)) {
        setQuestions(data.questions);
        if (data.pagination) {
          setPagination(data.pagination);
        }
      } else {
        throw new Error("Invalid response format");
      }
    } catch (err) {
      console.error("Error loading questions:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pagination.totalPages) return;
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  const handleEditQuestion = (questionId) => {
    // Find the question to edit
    const questionToEdit = questions.find((q) => q.question_id === questionId);
    if (questionToEdit) {
      setCurrentQuestion(questionToEdit);
      setIsEditQuestionModalOpen(true);
    }
  };

  const handleDeleteQuestion = async (questionId) => {
    const questionToUpdateStatus = questions.find((q) => q.question_id === questionId);
    console.log(questionToUpdateStatus)
    try {
      setLoading(true);
      const response = await fetch(
        `${apiBase}/quize/question/${questionId}`,
        {
          method: "PUT",
          headers: {
        "Content-Type": "application/json",
          },
          body: JSON.stringify({
          status: questionToUpdateStatus.status === 1 ? 0 : 1,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete question");
      }

      // Remove the question from the state
      setQuestions(questions.filter((q) => q.question_id !== questionId));
      // Refresh questions list if needed
      fetchQuestions();
    } catch (err) {
      console.error("Error deleting question:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddQuestion = () => {
    setIsAddQuestionModalOpen(true);
  };

  const handleCloseAddModal = () => {
    setIsAddQuestionModalOpen(false);
  };


  if (!isOpen) return null;

  console.log(currentQuestion)
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Quiz Questions
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 flex-grow overflow-y-auto">
          {error && (
            <div className="flex items-center p-4 mb-4 text-sm bg-red-50 border border-red-200 rounded-md text-red-800">
              <AlertCircle className="w-5 h-5 mr-2 flex-shrink-0" />
              <span>{error}</span>
            </div>
          )}

          {loading ? (
            <div className="flex justify-center items-center py-10">
              <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
              <span className="ml-2 text-gray-600">Loading questions...</span>
            </div>
          ) : questions.length > 0 ? (
            <div className="space-y-6">
              {questions.map((question, index) => {
                const questionNumber =
                  (pagination.currentPage - 1) * pagination.pageSize + index + 1;
                return (
                  <div
                    key={question.question_id}
                    className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50"
                  >
                    <div className="flex justify-between items-start mb-3">
                      <div className="flex-grow">
                        <h3 className="font-medium text-gray-900 mb-1">
                          {questionNumber + ". " + question.question_text || "No question text provided"}
                        </h3>
                        {question.question_img && (
                          <div className="mt-2">
                            <img
                              src={question.question_img}
                              alt="Question"
                              className="max-h-32 rounded-md"
                            />
                          </div>
                        )}
                      </div>
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleEditQuestion(question.question_id)}
                          className="p-1 text-blue-600 hover:text-blue-800"
                        >
                          <Pencil className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() =>
                            handleDeleteQuestion(question.question_id)
                          }
                          className="p-1 text-red-600 hover:text-red-800"
                        >
                          {
                            question.status === 1
                            ? (
                              <Trash2 className="w-4 h-4" />
                            ) : <EyeClosed className="w-4 h-4"/>
                          }
                          
                        </button>
                      </div>
                    </div>

                    {question.answers && question.answers.length > 0 ? (
                      <div className="mt-4 pl-4 border-l-2 border-gray-200 space-y-2">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">
                          Answers:
                        </h4>
                        {question.answers.map((answer) => (
                          <div
                            key={answer.answer_id}
                            className="flex items-start space-x-2"
                          >
                            <div
                              className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${
                                answer.is_correct
                                  ? "bg-green-100 text-green-600"
                                  : "bg-red-100 text-red-600"
                              }`}
                            >
                              {answer.is_correct ? (
                                <Check className="w-3 h-3" />
                              ) : (
                                <XIcon className="w-3 h-3" />
                              )}
                            </div>
                            <div className="flex-grow">
                              <p className="text-sm text-gray-800">
                                {answer.answer_text}
                              </p>
                              {answer.answer_img && (
                                <img
                                  src={answer.answer_img}
                                  alt="Answer"
                                  className="mt-1 max-h-16 rounded-md"
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-sm italic text-gray-500 mt-2">
                        No answers available
                      </p>
                    )}
                  </div>
                );
              })}

              {pagination.totalPages > 1 && (
                <div className="flex items-center justify-between py-3 border-t border-gray-200 mt-4">
                  <div className="flex-1 flex justify-between items-center">
                    <button
                      onClick={() =>
                        handlePageChange(pagination.currentPage - 1)
                      }
                      disabled={pagination.currentPage === 1}
                      className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    >
                      Previous
                    </button>
                    <span className="text-sm text-gray-700">
                      Page {pagination.currentPage} of {pagination.totalPages} (
                      {pagination.totalCount} items)
                    </span>
                    <button
                      onClick={() =>
                        handlePageChange(pagination.currentPage + 1)
                      }
                      disabled={
                        pagination.currentPage === pagination.totalPages
                      }
                      className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="py-10 text-center text-gray-500">
              No questions found for this quiz.
            </div>
          )}
        </div>

        <div className="px-6 py-4 border-t border-gray-200 flex justify-between">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Close
          </button>
          <button
            onClick={handleAddQuestion}
            className="px-4 py-2 bg-blue-600 rounded-md text-sm font-medium text-white hover:bg-blue-700 flex items-center"
          >
            <PlusCircle className="w-4 h-4 mr-1" />
            Add Question
          </button>
        </div>
      </div>

      {/* Add Question Modal */}
      {isAddQuestionModalOpen && (
        <CreateQuestion
          quizId={quizId}
          handleCloseAddModal={handleCloseAddModal}
          setRefreshFlag={setRefreshFlag}
        />
      )}

      {/* Edit Question Modal */}
      {isEditQuestionModalOpen && (
        <UpdateQuestion
          questionId={currentQuestion?.question_id}
          quizId={quizId}
          handleCloseUpdateModal={() => setIsEditQuestionModalOpen(false)}
          setRefreshFlag={setRefreshFlag}
        />
      )}
    </div>
  );
};

export default QuizeQuestions;
